import {APPROVE_OVERRIDE, APPROVE_OVERRIDE_SUCCESS, APPROVE_OVERRIDE_FAILURE, RESET_APPROVE_OVERRIDE} from '../actions';

const initialState = {
    loading :false,
    response: null,
    statusCode: '',
    statusMessage: '',
}

const approveOverrideReducer = (state = initialState, action) => {
    switch(action.type) {
        case APPROVE_OVERRIDE : 
            return {
    ...state,
   loading : true,
   response : null,
   statusCode : '',
   statusMessage : '',
}

case APPROVE_OVERRIDE_SUCCESS :
    return {

...state,
loading : false,
response : action.data,
statusCode : action.data?.statusCode || '',
statusMessage : action.data?.statusMessage || '',
    }

case APPROVE_OVERRIDE_FAILURE :
    return {
        ...state,
        loading : false,
        statusCode : action.data?.statusCode || '',
statusMessage : action.data?.statusMessage || '',
    }

case RESET_APPROVE_OVERRIDE :
    return {
        ...initialState,
    }

   default:
            return state;
    }
   
}
export default approveOverrideReducer;